<template>
  <div>
    <VModal
      v-model="config.modal"
      :title="refund_offline_apply.id ? '编辑退款申请' : '新建退款申请'"
      :loading="config.loading"
      :content-loading="loading"
      ok-text="保存"
      fullscreen
      @ok="save"
    >
      <v-form
        ref="form"
        v-model="data_valid"
        :disabled="loading"
        style="max-width: 1200px; margin: 0 auto;position:relative"
      >
        <v-row>
          <v-col cols="3">
            <VCustomerSelector
              v-model="refund_offline_apply.apply_customer_id"
              :rules="[v => v > 0 || '申请人不能为空']"
              :disabled="true"
              label="申请人"
            />
          </v-col>
          <v-col cols="3">
            <VTeamSelector
              v-model="refund_offline_apply.apply_team_id"
              :rules="[v => v > 0 || '请选择团队']"
              :disabled="true"
              :placeholder="null"
              label="团队"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              :value="refund_offline_apply.uid || '保存后自动生成'"
              label="单据编号"
              disabled
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              :value="getFillTime(refund_offline_apply)"
              label="填制时间"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.order_code"
              :rules="[v => !!v || '请填写订单编号']"
              label="订单编号"
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="refund_offline_apply.order_platform"
              :items="getOrderPlatformList()"
              item-text="label"
              item-value="value"
              label="订单平台"
              :rules="[v => !!v || '请选择订单平台']"
              @change="onOrderPlatformChange"
            />
          </v-col>
          <v-col cols="3">
            <VThirdPartyShop
              ref="shopSelector"
              v-model="refund_offline_apply.shop_id"
              :extra-data="shopExtraData"
              :rules="[v => (isMallOrOfflinePlatform ? true : (!!v && v > 0)) || '请选择店铺']"
              :disabled="isMallOrOfflinePlatform"
              label="店铺"
              @change="setShopInfo"
            />
          </v-col>
          <v-col cols="3">
            <VSpuSelector
              ref="spuSelector"
              v-model="refund_offline_apply.cya_spu_id"
              :rules="[v => !!v && v > 0 || '请选择SPU名称']"
              label="SPU名称"
              @change="setCyaSpuInfo"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="refund_offline_apply.refund_type"
              :items="getRefundTypeList()"
              item-text="label"
              item-value="value"
              label="退款类型"
              :rules="[v => !!v || '请选择退款类型']"
              @change="onRefundTypeChange"
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="refund_offline_apply.refund_reason"
              :items="filteredRefundReasonList"
              item-text="label"
              item-value="value"
              label="退款原因"
              :rules="[v => !!v || '请选择退款原因']"
              :disabled="refund_offline_apply.refund_type === 'coin'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="refund_offline_apply.company_id"
              :items="companies"
              item-text="short_name"
              item-value="id"
              label="退款主体"
              @change="onCompanyChange"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.refund_amount"
              :rules="[v => v >= 0 || '请填写退款金额']"
              label="退款金额"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.refund_coin_amount"
              :rules="[v => v >= 0 || '请填写学习币退币数量']"
              :disabled="refund_offline_apply.refund_type === 'direct'"
              label="学习币退币数量"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.user_id"
              :rules="[v => (isMallOrApplePlatform ? (!!v || '请填写用户ID') : true)]"
              label="用户ID"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.ali_payee_real_name"
              :rules="[v => !!v || '请填写支付宝收款人姓名']"
              label="支付宝收款人姓名"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.ali_payee_account"
              :rules="[v => !!v || '请填写支付宝账号']"
              label="支付宝账号"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="refund_offline_apply.account_nonuniqueness_explain"
              label="账户唯一性验证失败说明"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="refund_offline_apply.other_explain"
              :rules="[$rule.length({max: 500})]"
              :counter="500"
              rows="1"
              auto-grow
              label="其他说明"
              placeholder="备注信息..."
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              v-if="refund_offline_apply.error_msg"
            >
              验证信息：<span class="color-error"> {{ refund_offline_apply.error_msg }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              style="position: relative;min-height: 18px;"
            >
              <span
                class="v-label v-label--active theme--light"
                style="position: absolute; top: 0; left: 0; transform-origin: top left; display: inline-block; transform: scale(0.75)"
              >
                上传附件
              </span>
            </div>
            <EditAttachments
              :files="refund_offline_apply.bfiles"
              model_type="RefundOfflineApply"
              :model_id="refund_offline_apply.id"
            />
            <FileUploader
              :validate-file="validateFile"
              @uploaded="attachmentUploaded"
            />
            <span class="color-error">为保证兼容性，办公文档请上传office系列(Word, Excel, PPT)</span>
          </v-col>
        </v-row>
      </v-form>
    </VModal>
  </div>
</template>
<script>
import {
  getRefundOfflineApplySaveApi,
} from "./services";
import {OrderPlatformList, RefundReasonList, RefundTypeList} from "./constants"
import FileUploader from "@/views/components/file/uploader.vue";
import VModal from "@/vuetify_custom/v-modal_v1.vue";
import FlowUtil from "@/libs/flow_util";
import VCustomerSelector from "@/views/components/customer/v-selector.vue";
import moment from "moment/moment";
import VTeamSelector from "@/views/team/components/v-selector.vue";
import VSpuSelector from "./cya_spu_selector.vue"
import EditAttachments from "@/views/components/file/edit_attachments.vue";
import VThirdPartyShop from "./third_party_shop.vue"
import {mapGetters} from "vuex"

export default {
  components: {VThirdPartyShop, EditAttachments, VTeamSelector, VCustomerSelector, VModal, FileUploader, VSpuSelector},
  data() {
    this.initData();
    return {
      refund_offline_apply: {},
      loading: false,
      data_valid: true,
      shopExtraData: {}, // 用于传递给店铺选择器的额外数据
      config: {
        modal: false,
        loading: false
      }
    }
  },
  computed: {
    ...mapGetters({
      companies: 'async/companies',
    }),
    can_edit() {
      return FlowUtil.inEditNode(this.refund_offline_apply);
    },
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    filteredRefundReasonList() {
      // 如果退款类型是"学习币退款"，则不显示"退学习币"选项
      if (this.refund_offline_apply.refund_type === 'direct') {
        return RefundReasonList.filter(item => item.value !== 'refund_coin');
      }
      // 如果退款类型不是"直接退款"，则不显示"苹果支付（仅退款）"选项
      return RefundReasonList.filter(item => item.value !== 'apple_pay_only_refund');
    },
    isMallOrOfflinePlatform() {
      // 判断当前选择的订单平台是否为"商城"或"线下收款"
      return this.refund_offline_apply.order_platform === 'mall' || 
             this.refund_offline_apply.order_platform === 'offline_pay';
    },
    isMallOrApplePlatform() {
      // 判断当前选择的订单平台是否为"商城"或"苹果"
      return this.refund_offline_apply.order_platform === 'mall' ||
          this.refund_offline_apply.order_platform === 'apple';
    }
  },
  mounted() {
  },
  methods: {
    getRefundTypeList() {
      // 如果订单平台是非苹果平台，则只允许直接退款
      if (this.refund_offline_apply.order_platform && this.refund_offline_apply.order_platform !== 'apple') {
        return RefundTypeList.filter(item => item.value === 'direct');
      }
      return RefundTypeList;
    },
    getOrderPlatformList() {
      return OrderPlatformList
    },
    getRefundReasonList() {
      return RefundReasonList
    },
    edit(roa_data) {
      this.config.modal = true;
      if (roa_data) {
        this.refund_offline_apply = {...roa_data};
      } else {
        this.initData();
      }
    },
    initData() {
      const customer = this.cur_customer || {};
      this.refund_offline_apply = {
        apply_customer_id: customer.id || 0,
        apply_team_id: customer.root_team_id || 0,
        shop_id: 0,
        shop_name: "选择店铺",
        order_platform: "",
        order_code: "",
        user_id: "",
        refund_type: "",
        cya_spu_id: 0,
        cya_spu_name: "选择SPU名称",
        refund_reason: "",
        refund_amount: 0,
        refund_coin_amount: 0,
        ali_payee_account: "",
        ali_payee_real_name: "",
        company_id: 0,
        other_explain: "",
        error_msg: "",
        account_nonuniqueness_explain: "",
        status: "",
        bfiles: []
      };
      this.setDefaultValues();
    },
    save() {
      this.$refs.form.validate();
      if (!this.data_valid) {
        this.$Message.error('请检查并完善必填信息');
        this.config.loading = false;
        return;
      }

      this.config.loading = true;
      getRefundOfflineApplySaveApi(this.refund_offline_apply).then(res => {
        this.$Message.success(res);
        this.$emit("save");
        this.config.modal = false;
      }).finally(() => {
        this.config.loading = false;
      });
    },
    setDefaultValues() {
      const customer = this.cur_customer;
      if (customer && customer.id) {
        this.refund_offline_apply.apply_team_id = customer.root_team_id;
        this.setApplyUser(customer);
      }
    },
    setApplyUser(customer) {
      this.refund_offline_apply.apply_customer_id = customer.id;
    },
    getFillTime(apply) {
      const time = apply.created_at || new Date();
      return moment(time).format('YYYY-MM-DD');
    },
    setCyaSpuInfo(spu) {
      this.refund_offline_apply.cya_spu_id = spu.id
      this.refund_offline_apply.cya_spu_name = spu.spu_name
      this.refund_offline_apply.company_id = spu.company_id
    },
    setShopInfo(shop) {
      this.refund_offline_apply.shop_id = shop.id
      this.refund_offline_apply.shop_name = shop.shop_name
    },
    onOrderPlatformChange() {
      // 当订单平台改变时，更新店铺选择器的extraData
      // 查找当前选中平台的label
      const platformItem = this.getOrderPlatformList().find(
          item => item.value === this.refund_offline_apply.order_platform
      );

      this.shopExtraData = {
        shop_platform: platformItem ? platformItem.label : ''
      };

      // 如果不是商城或线下收款平台，清空已选择的店铺
      if (this.refund_offline_apply.order_platform !== 'mall' && 
          this.refund_offline_apply.order_platform !== 'offline_pay') {
        this.refund_offline_apply.shop_id = 0;
        this.refund_offline_apply.shop_name = "选择店铺";

        // 如果有店铺选择器组件实例，重置其状态
        if (this.$refs.shopSelector) {
          this.$refs.shopSelector.clear();
        }
      } else {
        // 如果是商城或线下收款平台，设置默认值
        this.refund_offline_apply.shop_id = 0;
        this.refund_offline_apply.shop_name = "";
      }
    },
    // 添加refund_type变化的监听方法
    onRefundTypeChange() {
      if (this.refund_offline_apply.refund_type === 'direct') {
        this.refund_offline_apply.refund_coin_amount = 0;
        // 如果当前退款原因是"退学习币"，则清空
        if (this.refund_offline_apply.refund_reason === 'refund_coin') {
          this.refund_offline_apply.refund_reason = '';
        }
      } else if (this.refund_offline_apply.refund_type === 'coin') {
        // 如果是学习币退款，自动设置退款原因为"退学习币"
        this.refund_offline_apply.refund_reason = 'refund_coin';
      }
    },
    // 公司选择变化时的处理方法
    onCompanyChange() {
      // 可以在这里添加额外的逻辑
    },
    attachmentUploaded(bfile) {
      this.refund_offline_apply.bfiles.push(bfile);
    },
    validateFile(file) {
      const a = /\.[0-9a-zA-Z]+$/.test(file.name)
      if (!a) {
        this.$vModal.warning({
          title: '提示',
          content: '文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
        })
      }
      return a
    }
  }
}
</script>